'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotHistogram2dBricksIcon = function PlotHistogram2dBricksIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M15 7.063H6v4.625h9zm11 0h-9v4.625h9zM6 24.938h9v-4.625H6zm11 0h9v-4.625h-9zm-5.5-6.625h9v-4.625h-9zm11-4.625v4.625h9v-4.625zm-13 0h-9v4.625h9z' })
    );
};

exports.default = PlotHistogram2dBricksIcon;